import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import { Dropdown, Menu, Input, Checkbox, Button, Col, Row } from "antd";
import { iff } from "core/iff";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getAllOrganizationFromCurrentWorkspace,
  getAllPropertiesFromCurrentWorkspace,
} from "services/MemberService";
import { arrayofIds, translationWrapper } from "utils/common-methods";
import "./styles.less";
import { OrganizationDTO } from "core/orgs/models";
import { isEmpty } from "lodash";
import { PropertyDTO } from "core/property/models";

export const ShowAllOrganizationDropdown = (props: {
  handleFilterChange: any;
  currentWorkspaceId: string;
}) => {
  const { handleFilterChange, currentWorkspaceId } = props;
  const { t } = translationWrapper(useTranslation(), false);
  const defaultCheckedList = [""];
  const [allOrganizationData, setAllOrganizationData] = useState<OrganizationDTO[]>([]);
  const [allPropertiesData, setAllPropertiesData] = useState<PropertyDTO[]>([]);
  const [searchedValue, setSearchedValue] = useState("");
  const [selectedSubmenuItem, setSelectedSubmenuItem] = useState(0);
  const [showSubMenuBox, setShowSubmenuBox] = useState(false);
  const [checkedList, setCheckedList] = useState(defaultCheckedList);
  const [indeterminate, setIndeterminate] = useState(true);
  const [checkAll, setCheckAll] = useState(false);
  const [allOrganizationFilteredData, setAllOrganizationFilteredData] = useState<OrganizationDTO[]>([]);
  const [allPropertiesFilteredData, setAllPropertiesFilteredData] = useState<PropertyDTO[]>([]);

  const onChange = (list: any) => {
    setCheckedList(list);
    if (
      dropdownSubmenuItems[selectedSubmenuItem].title === "All organizations"
    ) {
      setIndeterminate(
        !!list.length && list.length < allOrganizationFilteredData.length
      );
      setCheckAll(list.length === allOrganizationData.length);
    } else {
      setIndeterminate(
        !!list.length && list.length < allPropertiesFilteredData.length
      );
      setCheckAll(list.length === allPropertiesData.length);
    }
  };

  const handleClear = () => {
    setSearchedValue("");
    setShowSubmenuBox(false);
    setCheckedList([]);
    handleFilterChange([]);
    setCheckAll(false);
  };

  const handleApply = () => {
    handleFilterChange(checkedList);
    setShowSubmenuBox(false);
  };

  const onCheckAllChange = (e: any) => {
    dropdownSubmenuItems[selectedSubmenuItem].title === "All organizations"
      ? setCheckedList(iff(e.target.checked, allOrganizationData, []))
      : setCheckedList(iff(e.target.checked, allPropertiesData, []));
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const dropdownSubmenuItems = [
    {
      title: "All organizations",
      placeholder: "Search a organization",
    },
    {
      title: "All farms",
      placeholder: "Search a farm",
    },
  ];

  useEffect(() => {
    if (searchedValue && searchedValue !== "") {
      const searchedDataToBeFilter = () => {
        if (
          dropdownSubmenuItems[selectedSubmenuItem].title ===
          "All organizations"
        ) {
          return allOrganizationData;
        } else {
          return allPropertiesData;
        }
      };

      const searchedData = (searchedDataToBeFilter() as any).filter((el: any) => {
        return el.name && el.name.search(new RegExp(searchedValue, "i")) !== -1;
      });

      iff(
        dropdownSubmenuItems[selectedSubmenuItem].title === "All organizations",
        setAllOrganizationFilteredData(searchedData),
        setAllPropertiesFilteredData(searchedData)
      );
    } else {
      iff(
        dropdownSubmenuItems[selectedSubmenuItem].title === "All organizations",
        setAllOrganizationFilteredData(allOrganizationData),
        setAllPropertiesFilteredData(allPropertiesData)
      );
    }
  }, [searchedValue]);

  const handleDropdownMenuItemCLicked = (key: any) => {
    setSelectedSubmenuItem(key);
    setCheckedList([]);
    setCheckAll(false);
  };

  const menu = (
    <Menu
      className="show-all-org-dropdown-menu-container"
      selectable
      defaultSelectedKeys={["0"]}
    >
      <Menu.Item
        onClick={() => handleDropdownMenuItemCLicked(0)}
        key="0"
        className="show-all-org-dropdown-menu-item-container"
      >
        {t("Organization")}
      </Menu.Item>
      <Menu.Item
        onClick={() => handleDropdownMenuItemCLicked(1)}
        key="1"
        className="show-all-org-dropdown-menu-item-container"
      >
        {t("Farm")}
      </Menu.Item>
    </Menu>
  );
  const getAllOrganizationsandProperties = async () => {
    const getAllOrganizationsResponse =
      (await getAllOrganizationFromCurrentWorkspace(currentWorkspaceId))
        ?.data.content as OrganizationDTO[];

    if (!isEmpty(getAllOrganizationsResponse)) {
      const getAllPropertiesResponse =
        (await getAllPropertiesFromCurrentWorkspace(
          arrayofIds(getAllOrganizationsResponse)
        ))?.data.content as PropertyDTO[];
      if (!isEmpty(getAllPropertiesResponse)) {
        setAllPropertiesData(getAllPropertiesResponse);
        setAllPropertiesFilteredData(getAllPropertiesResponse);
      }
      setAllOrganizationData(getAllOrganizationsResponse);
      setAllOrganizationFilteredData(getAllOrganizationsResponse);
    }
  };
  useEffect(() => {
    if(currentWorkspaceId) {
      getAllOrganizationsandProperties();
    }
  }, [currentWorkspaceId]);

  const dataToBeDisplay = () => {
    if (
      dropdownSubmenuItems[selectedSubmenuItem].title === "All organizations"
    ) {
      return allOrganizationFilteredData;
    } else {
      return allPropertiesFilteredData;
    }
  };

  return (
    <> 
    <div className="dropdown_container">
      <div style={{ fontSize: "14px", width: "max-content", margin: "auto" }}>
        <Dropdown overlay={menu} trigger={["click"]} visible={showSubMenuBox}>
          <a
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowSubmenuBox(true);
            }}
          >
            {t("Show all organizations")}
            <DownOutlined style={{ marginLeft: "8.5px" }} />
          </a>
        </Dropdown>
      </div>
      {showSubMenuBox && (
        <div className="show-all-org-dropdown-submenu-container">
          <div className="show-all-org-dropdown-submenu-inputbox">
            <Input
              onChange={(e) => {
                e.preventDefault();
                setSearchedValue(e.target.value);
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
              prefix={<SearchOutlined />}
              value={searchedValue}
              placeholder={
                dropdownSubmenuItems[selectedSubmenuItem].placeholder
              }
            />
          </div>
          <div className="show-all-org-dropdown-submenu-list">
            <Checkbox
              indeterminate={indeterminate}
              onChange={onCheckAllChange}
              checked={checkAll}
            >
              {dropdownSubmenuItems[selectedSubmenuItem].title}
            </Checkbox>
            <Checkbox.Group
              style={{ width: "100%" }}
              onChange={onChange}
              value={checkedList}
            >
             <Row>
                {(allOrganizationFilteredData &&
                  allPropertiesFilteredData) &&
                  dataToBeDisplay().map((el: any, key: any) => {
                    return (
                      <Col key={key}>
                        <Checkbox value={el}>{el.name}</Checkbox>
                      </Col>
                    );
                  })}
              </Row>
            </Checkbox.Group>
          </div>
          <div className="show-all-org-dropdown-footer">
            <Button
              onClick={handleClear}
              className="show-all-org-dropdown-clear-btn"
            >
              {t("Clear")}
            </Button>
            <Button
              className="show-all-org-dropdown-apply-btn"
              onClick={handleApply}
            >
              {t("Apply")}
            </Button>
          </div>
        </div>
      )}
      </div>
    </>
  );
};